import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { Trans } from 'react-i18next';
import TextTooltipOnHover from '../Popover/Preset/TextTooltipOnHover';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './ProfileStatItems.scss';
function placeCommasInNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export class ProfileStatItems extends React.Component {
    render() {
        const { defaultStats , additionalStats , itemClassName , countClassName , statsData , isMobile  } = this.props;
        const stats = [
            ...defaultStats,
            ...additionalStats
        ];
        return stats.map((stat)=>{
            const statValue = statsData[stat] || 0;
            const formattedCount = shortenNumber(statValue);
            const isTooltipNeeded = Number(formattedCount) !== statValue;
            return /*#__PURE__*/ React.createElement("span", {
                key: stat,
                className: classnames(s['item'], itemClassName)
            }, /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: `profileStats.${stat}`,
                count: statValue
            }, !isMobile && isTooltipNeeded ? /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
                key: stat,
                tooltipText: placeCommasInNumber(statValue),
                className: classnames(s['tooltip-wrap'], countClassName)
            }, formattedCount) : /*#__PURE__*/ React.createElement("span", {
                className: countClassName
            }, formattedCount), "\xa0", stat));
        });
    }
}
const enhance = compose(withMobileContext);
export default enhance(ProfileStatItems);
